import React from "react"
import * as styles from "src/styles/contact_card.module.scss"
import { graphql, useStaticQuery } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import Card from "./Card"

export default function ContactCard({ title, phone, email }) {
  const data = useStaticQuery(graphql`
    query images {
      call_image: file(relativePath: { eq: "icons/call.png" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      email_image: file(relativePath: { eq: "icons/mail.png" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
    }
  `)

  return (
    <Card>
      <h2 className={styles.card_topic}>{title}</h2>
      <div className={styles.icon_list}>
        <GatsbyImage
          className={styles.icon}
          image={getImage(data.call_image)}
          alt="Call"
        />
        <p className={styles.details}>{phone}</p>
      </div>
      <div className={styles.icon_list}>
        <GatsbyImage
          className={styles.icon}
          image={getImage(data.email_image)}
          alt="Email"
        />
        <p className={styles.details}>{email}</p>
      </div>
    </Card>
  )
}
